/**
 * جایگزین سبک برای `vue-toastr` (که فقط Vue 2 بود).
 *
 * همان API قبلی را می‌دهد تا صدها فراخوانی `this.$toastr.s(msg, title)` در کامپوننت‌ها
 * بدون تغییر کار کنند. رندر توسط `ToastHost.vue` (در App.vue) انجام می‌شود.
 */
import { reactive } from "vue";

export const toastState = reactive({ items: [] });

let seq = 0;
const DURATION = 4500;

export function removeToast(id) {
    const i = toastState.items.findIndex((x) => x.id === id);
    if (i !== -1) toastState.items.splice(i, 1);
}

function push(type, msg, title) {
    const id = ++seq;
    toastState.items.push({
        id,
        type,
        msg: msg == null ? "" : String(msg),
        title: title ? String(title) : "",
    });
    // حداکثر ۵ مورد هم‌زمان
    if (toastState.items.length > 5) toastState.items.shift();
    setTimeout(() => removeToast(id), DURATION);
    return id;
}

export const toastr = {
    s: (msg, title) => push("success", msg, title),
    e: (msg, title) => push("danger", msg, title),
    w: (msg, title) => push("warning", msg, title),
    i: (msg, title) => push("info", msg, title),
    remove: removeToast,
};

export default {
    install(app) {
        app.config.globalProperties.$toastr = toastr;
    },
};
